<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">快递业务</el-breadcrumb-item>
        <el-breadcrumb-item>导入快递月结单</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <div v-if="!details && !id" class="storedialog load-dialog" style="text-align: center">
      <div class="download" style="margin: 10px auto">
        点击下载模板：
        <a target="_blank" :href="templateUrl"> 快递月结单导入模板.xlsx </a>
      </div>

      <el-upload class="upload-box" ref="upload" action="#" :http-request="submitUpload" :auto-upload="true" drag
        :limit="1">
        <el-icon style="font-size:3em;">
          <UploadFilled />
        </el-icon>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip">
          注：Excel表格里的填写项请严格按照模板内容进行填写
        </div>
      </el-upload>
    </div>

    <div v-if="details || id">
      <el-form :model="master" ref="master" :rules="rules" class="detail-form" @submit.prevent>
        <el-row>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item label="地区编号：" prop="districtCode">
              <el-col>
                <el-input v-model="master.districtCode"> </el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item label-width="130px" label="客户名称:" prop="parterName">
              <el-col>
                <el-input v-model="master.parterName"> </el-input>
              </el-col>
            </el-form-item>
          </el-col>

          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item label-width="130px" label="账单日期:" prop="billDate">
              <el-col>
                <el-date-picker v-model="master.billDate" type="date" placeholder="" format="YYYY-MM-DD"
                  style="max-width: 90%"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item label="联系人员：" prop="contactName">
              <el-col>
                <el-input v-model="master.contactName"> </el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item label-width="130px" label="联系人电话:" prop="contactPhone">
              <el-col>
                <el-input v-model="master.contactPhone"> </el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
            <el-form-item label="备注信息：" prop="remark">
              <el-input type="textarea" placeholder="请输入备注内容" v-model="master.remark" maxlength="1000" show-word-limit
                :rows="2" style="width: 88%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18"> </el-col>
          <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" style="text-align: right">
            <el-form-item>
              <el-button type="primary" icon="check" @click="submitEvent" v-if="!master.id">
                保存
              </el-button>
              <el-button type="info" icon="back" @click="back()">
                返回
              </el-button>
              <el-button v-if="master.id" type="primary" @click="exportEvent" icon="download">
                导出
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table class="table" ref="detailTable" :data="details" border size="small" height="450">
        <!-- <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column> -->
        <el-table-column prop="sortCode" label="序号" align="center" width="50"> </el-table-column>
        <el-table-column prop="detailDate" label="单据日期" width="100">
          <template #default="scope">
            {{ scope.row.detailDate.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column prop="detailNo" label="单据编号" sortable width="150">
          <template #default="scope">
            <el-tooltip v-if="scope.row.status == -1" class="item" effect="dark" :content="scope.row.remark"
              placement="top-start">
              <el-link type="danger" size="small" disabled>{{ scope.row.detailNo }}</el-link>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status == 1" class="item" effect="dark" :content="scope.row.remark"
              placement="top-start">
              <el-link type="success" size="small" disabled>{{ scope.row.detailNo }}</el-link>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="originPlace" label="寄出地点" width="90"> </el-table-column>
        <el-table-column prop="targetPlace" label="目标地点" width="110"> </el-table-column>
        <el-table-column prop="companyName" label="对方公司名称" width="110"> </el-table-column>
        <el-table-column prop="scaleWeight" label="计费重量" sortable width="100"> </el-table-column>
        <el-table-column prop="expressName" label="产品类型" sortable width="100"> </el-table-column>
        <el-table-column prop="payType" label="付款方式" width="70"> </el-table-column>
        <el-table-column prop="scaleFee" label="费用(元)" width="70"> </el-table-column>
        <el-table-column prop="scaleDis" label="促销/折扣" width="80"> </el-table-column>
        <el-table-column prop="scalePay" label="应付金额" width="80"> </el-table-column>
        <el-table-column prop="operater" label="经手人" width="70"> </el-table-column>
        <el-table-column prop="otherFee" label="增值费用" width="80"> </el-table-column>
        <el-table-column prop="systemFee" label="系统计算费用" width="100"> </el-table-column>
        <el-table-column prop="remark" label="备注" width="180"> </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { uploader } from "@/api/subupload";
import { PreBill, submitMailBill, fetchBillInfo, exportMailBill } from "@/api/mailscale";
export default {
  name: "billDetail",
  data() {
    return {
      templateUrl: process.env.VUE_APP_BASEURL + "/static/template/mailbill.xlsx",
      master: {},
      details: null,
      id: null,

      rules: {
        districtCode: [
          { required: true, message: "请输入地区编号", trigger: "blur" },
        ],
        parterName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
        contactName: [
          { required: true, message: "请输入联系人信息", trigger: "blur" },
        ],
        billDate: [
          { required: true, message: "请输入账单日期", trigger: "blur" },
        ],
        remark: [
          { required: true, message: "请输入备注信息", trigger: "blur" },
        ]
      },
    };
  },
  methods: {
    //上传操作
    submitUpload(file) {
      var dataList = new FormData();
      dataList.append(file.file.name, file.file);
      dataList.append("fileType", "excel");
      dataList.append("dataType", "MailScale");
      this.$refs.upload.clearFiles();

      uploader(dataList)
        .then((res) => {
          if (res.code === 200) {
            this.$message({ message: "上传成功", type: "success" });
            this.dataId = res.data[0].id;
          } else {
            this.$message.error("上传失败，请重试");
          }
        })
        .then(() => {
          PreBill(this.dataId).then(
            (res) => {
              if (res.code === 200) {
                console.log(Object.values({ ...res.data }));
                this.details = res.data;
              }
            },
            (err) => {
              console.log(err);
            }
          );
        });
    },

    submitEvent() {
      let dtos = {
        master: this.master,
        details: this.details,
      };

      dtos.master.billDate = this.$util.fmtDate(dtos.master.billDate, "yyyy-MM-dd");
      console.log(dtos);
      let that = this;

      this.$refs.master.validate((valid) => {
        if (!valid) return;

        submitMailBill(dtos).then((res) => {
          that.$message({ type: res.type, message: res.content });
          if (res.code == 200) {
            //that.$router.back(-1);
            that.master = res.data.master;
            that.details = res.data.details;
          }
        });
      });
    },

    fetchs(masterId) {
      let that = this;
      fetchBillInfo(masterId).then((res) => {
        that.master = res.data.master;
        that.details = res.data.details;
        that.rules = [];
      });
    },
    //打印
    onprint() {
      print(this.$refs.print);
    },
    back() {
      this.$router.go(-1);
    },

    exportEvent() {
      exportMailBill(this.id).then((res) => {
        if (res.code == 200)
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
      });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id) this.fetchs(this.id);
  },
};
</script>
<style lang="less"></style>